export default __webpack_public_path__ + "static/media/metaverse3.54944581.jpg";